import { render, staticRenderFns } from "./corneaContact.vue?vue&type=template&id=e505a75a&scoped=true&"
import script from "./corneaContact.vue?vue&type=script&lang=js&"
export * from "./corneaContact.vue?vue&type=script&lang=js&"
import style0 from "./corneaContact.vue?vue&type=style&index=0&id=e505a75a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e505a75a",
  null
  
)

export default component.exports